import {Board} from 'models/board';
import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {addBoard, boardSelector, removeBoard, setBoardSearch, setSelectedBoard} from '../../store/boards/boardSlice';
import {BoardFormModel} from 'models/board/boardDynamicForm.model';

export const useBoardRedux = () => {
    const dispatch = useDispatch();
    const {boardsRedux, selectedBoardRedux, selectDefaultBoardForm} = useSelector(boardSelector);

    const selectedDefaultForm: BoardFormModel = useMemo(() => {
        return (
            selectDefaultBoardForm ??
            ({
                formFieldsData: [],
                isDefault: true,
                id: '',
                title: '',
                boardId: '',
                summaryViews: [],
            } as BoardFormModel)
        );
    }, [selectDefaultBoardForm]);
    const selectedBoard = useMemo(() => {
        return selectedBoardRedux;
    }, [selectedBoardRedux]);
    const allBoards = useMemo(() => {
        return boardsRedux;
    }, [boardsRedux]);

    const setBoardsInRedux = useCallback(
        (value: Board[]) => {
            dispatch(addBoard(value));
        },
        [dispatch],
    );
    const setBoardSearchValue = useCallback(
        (value?: string) => {
            dispatch(setBoardSearch(value));
        },
        [dispatch],
    );
    const addNewBoardInRedux = useCallback(
        (value: Board) => {
            dispatch(addBoard([...boardsRedux, value]));
        },
        [dispatch, boardsRedux],
    );
    const removeBoardFromRedux = useCallback(
        (value: string) => {
            dispatch(removeBoard(value));
        },
        [dispatch],
    );
    const setSelectedBoardInRedux = useCallback(
        (value: Board | null) => {
            dispatch(setSelectedBoard(value));
        },
        [dispatch],
    );
    return {
        setBoardSearchValue,
        setSelectedBoardInRedux,
        removeBoardFromRedux,
        addNewBoardInRedux,
        setBoardsInRedux,
        allBoards,
        selectedBoard,
        selectedDefaultForm,
    };
};
